import { vUser } from '@models/Views/vUser';
import { tRole } from '@models/Tables/tRole';

export class vUserX extends vUser {
    roles: tRole[] = [];

    isAdmin: boolean;
    isTrafficPay: boolean;
    isSysop: boolean;
}
